import { RPCFactory } from '../utils/RequestUtil';
import React from 'react';
import { connect } from 'react-redux';
import { store } from '../store/Store';
import { GlobalStateAction } from '../actions/GlobalStateAction';

const mapStateToProps = (state) => ({ ...state.employee });

export function withEmployeeList(Component) {
  class WithEmployeeListComponent extends React.Component {
    componentDidMount() {
      if (this.props.employeeStatus === 'init') {
        this.getEmployeeList();
      }
    }
    getEmployeeList = () => {
      store.dispatch({
        type: GlobalStateAction.EMPLOYEE_LIST_SEARCHING,
      });
      RPCFactory.employeeManage
        .getEmployees(undefined, undefined, undefined, undefined, undefined, undefined)
        .done((data) => {
          store.dispatch({
            type: GlobalStateAction.SET_EMPLOYEE_LIST,
            payload: {
              employeeList: data.entities,
            },
          });
        })
        .fail((ret, msg) => {
          window.alert(`获取团队列表错误：${msg}`);
        });
    }
    render() {
      return <Component {...this.props} employeeList={this.props.employeeList} />;
    }
  }

  return connect(mapStateToProps)(WithEmployeeListComponent);
}
